<template>
  <div id="app">
    <DialogProvider :ModalComponent="LnDialogVue">
      <!-- <keep-alive> -->
      <router-view />
      <!-- </keep-alive> -->
    </DialogProvider>
  </div>
</template>

<script>
import { DialogProvider } from '@/features/dialog';
import LnDialogVue from '@/features/dialog/LnDialog.vue';
import { keepAliveInclude } from './hooks/useKeepAlive';
import { resolvePageMetaConfig } from '@/utils/domain';
import router from './router';

const setPageMeta = ({ title, description, favicon }) => {
  if (title) {
    document.title = title;
  }

  if (description) {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      document.head.appendChild(meta);
    }
  }

  if (favicon) {
    let faviconNode = document.head.querySelector('link[rel="icon"]');
    if (faviconNode !== null) {
      faviconNode.href = favicon;
    } else {
      faviconNode = document.createElement('link');
      faviconNode.rel = 'shortcut icon';
      faviconNode.href = favicon;
      document.head.appendChild(faviconNode);
    }
  }
};

export default {
  name: 'app',
  components: {
    DialogProvider
  },
  setup() {
    const area = router.currentRoute.query.area;
    const pageMetaConfig = resolvePageMetaConfig(area);
    if (pageMetaConfig) {
      setPageMeta(pageMetaConfig);
    }
    return {
      LnDialogVue,
      keepAliveInclude
    };
  }
};
</script>

<style lang="scss">
.part-title {
  font-family: SourceHanSansCN;
  font-weight: 800;
  font-size: 0.3rem;
  color: #000000;
  display: flex;
  align-items: center;
  padding: 0.2rem 0;

  &::before {
    content: '';
    display: inline-block;
    width: 0.08rem;
    height: 0.45rem;
    background: #ffc100;
    margin-right: 0.15rem;
  }
}
</style>
